import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Covert Cache",
  date: new Date(2024, 3, 28),
  img: "/img/robot-harvest.jpeg",
  video: "/videos/robot-harvest.mp4",
  tracks: [
    {
      title: "Mechanized Labor Normalized",
      src: "/songs/2024-04-28/06-mechanized-labor-normalized.mp3",
      duration: 238.248,
    },
    {
      title: "EnteroBacter",
      src: "/songs/2024-04-28/07-enterobacter.mp3",
      duration: 491.184,
    },
    {
      title: "Secondary Non Responder",
      src: "/songs/2024-04-28/08-secondary-non-responder-1.mp3",
      duration: 345.312,
    },
    {
      title: "Dawn Phenomenon",
      src: "/songs/2024-04-28/09-dawn-phenomenon.mp3",
      duration: 277.2,
    },
    {
      title: "Cost and Coverage Barriers",
      src: "/songs/2024-04-28/11-cost-and-coverage-barriers.mp3",
      duration: 323.568,
    },
    {
      title: "12 Hidden Digits",
      src: "/songs/2024-04-28/12-hidden-digits2.mp3",
      duration: 559.176,
    },
    {
      title: "Sustained Release",
      src: "/songs/2024-04-28/12-sustained-release.mp3",
      duration: 781.32,
    },
    {
      title: "Chase 'Em Down",
      src: "/songs/2024-04-28/chase-em-down.mp3",
      duration: 776.88,
    },
    {
      title: "Gestational Surrogacy",
      src: "/songs/2024-04-28/gestational-surrogacy.mp3",
      duration: 381.72,
    },
    {
      title: "Harvey Bradsaw Index",
      src: "/songs/2024-04-28/harvey-bradshaw-index.mp3",
      duration: 522.5273469387755,
    },
    {
      title: "Opening BeatBox",
      src: "/songs/2024-04-28/opening-beat-box.mp3",
      duration: 43.8,
    },
  ],
};
export default album;
